import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics, isSupported as isAnalyticsSupported } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

/** Prefer the custom domain on production for Auth. */
function resolveAuthDomain() {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'successbridgeacademy.com' || host === 'www.successbridgeacademy.com') {
      return host;
    }
  }
  return 'gedprep-c8dc2.firebaseapp.com';
}

const firebaseConfig = {
  apiKey: 'AIzaSyAsmnyU9OUc8ja9htHRrxIOLy5NaC-ebus',
  authDomain: resolveAuthDomain(),
  projectId: 'gedprep-c8dc2',
  storageBucket: 'gedprep-c8dc2.firebasestorage.app',
  messagingSenderId: '475136473863',
  appId: '1:475136473863:web:380960c55d01cf0ddc23a2',
  measurementId: 'G-KP4MG3F9RG',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

/** Safe on Safari / ITP — never block app boot if Analytics is unavailable */
export let analytics = null;
isAnalyticsSupported()
  .then((ok) => {
    if (ok) analytics = getAnalytics(app);
  })
  .catch(() => {
    analytics = null;
  });

export default app;
